












































import { routeInfos } from "@/router/routes";
import { Component, Vue } from "vue-property-decorator";
import LoginFormBoxComponent from "@/components/common/form/LoginFormBoxComponent.vue";
import InputComponent from "@/components/common/form/InputComponent.vue";
import ErrorBarComponent from "@/components/common/parts/ErrorBarComponent.vue";
import FooterComponent from "@/components/layout/FooterComponent.vue";
import { postTokenApi } from "@/typescript/api_client/emesh_api/login/token_api";
import {
  AccessToken,
  AccessTokenError
} from "@/typescript/api_client/emesh_api/login/types";
export { AccessToken, AccessTokenError };

@Component({
  components: {
    LoginFormBoxComponent,
    InputComponent,
    ErrorBarComponent,
    FooterComponent
  }
})
export default class LoginPage extends Vue {
  routeInfos = routeInfos;
  loginId: string = "";
  password: string = "";
  errorMsg: string = "";

  login() {
    postTokenApi(this.loginId, this.password)
      .then((resp: AccessToken) => {
        this.$store.commit("setAuthInfo", {
          authInfo: resp
        });
        this.$router.push("/dashboard");
      })
      .catch((e: AccessTokenError) => {
        this.errorMsg = e.error;
      });
  }

  setValue(key: string, value: string) {
    this[key] = value;
  }
}
